var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 32H32C14.312 32 0 46.312 0 64V128C0 136.812 7.188 144 16 144H32V432C32 458.508 53.49 480 80 480H432C458.51 480 480 458.508 480 432V144H496C504.812 144 512 136.812 512 128V64C512 46.312 497.688 32 480 32ZM464 432C464 449.645 449.645 464 432 464H80C62.355 464 48 449.645 48 432V144H464V432ZM496 128H16V64C16 55.18 23.178 48 32 48H480C488.822 48 496 55.18 496 64V128ZM168 256H344C348.418 256 352 252.418 352 248S348.418 240 344 240H168C163.582 240 160 243.582 160 248S163.582 256 168 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArchive);
export default __webpack_public_path__ + "static/media/box-archive.0c3516827702b5c56ef456baff4a065d.svg";
export { ForwardRef as ReactComponent };